import React, { Component } from 'react';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import FrontNav from '../../../components/FrontNav';
import TabNav from '../../../components/TabNav';
import ResourceTaggedList from '../../../components/Activity/Resource/ResourceTaggedList';

class ScreenResourcesList extends Component {
	render () {
		return (
			<section>
				<Header />
				<FrontNav match={this.props.match} />
				<TabNav match={this.props.match} />
			    <ResourceTaggedList tag={this.props.match.params.tag} props={this.props} />
			    <Footer />
			</section>
		)
	}
}

export default ScreenResourcesList;